import checkPermission from "@/utils/checkPermission";

export function permission(el, binding) {
  let permission = binding.value
  if (!checkPermission(permission)) {
    el.style.display = 'none'
  }
}